export default {
   fusionstoreLink: {
      prefix: 'https://s3.eu-central-1.amazonaws.com/fusion.store/',
      postfix: '-all.json',
   },
   themes: [
      { text: 'Fusion', value: 'fusion' },
      { text: 'Gammel', value: 'gammel' },
      { text: 'Candy', value: 'candy' },
      { text: 'Umber', value: 'umber' },
   ],
   ftThemes: [
      { text: 'Fusion', value: 'fusion' },
      { text: 'Gammel', value: 'gammel' },
      { text: 'Candy', value: 'candy' },
      { text: 'Umber', value: 'umber' },
   ],
   defaultTheme: 'gammel',
};
